// De transcriberstap loopt door drie schermen: eerst instellen, dan het gesprek
// voeren, dan de samenvatting beoordelen en wegschrijven.
export enum TranscriberPhaseEnum {
	SETUP = 'SETUP',
	RECORDING = 'RECORDING',
	SUMMARY = 'SUMMARY',
}
